import React from 'react'
import Link from 'gatsby-link'

import logo from '../pages/logo_cesartia.svg'

const Header = () => (
  // <div style={{ background: 'rebeccapurple', marginBottom: '1.45rem' }} >
  //   <div style={{ margin: '0 auto', maxWidth: 960, padding: '1.45rem 1.0875rem' }}>
  //     <h1 style={{ margin: 0 }}>
  //       <Link to="/" style={{ color: 'white', textDecoration: 'none'}}>
  //         Gatsby
  //       </Link>
  //     </h1>
  //   </div>

  <div className="m__logo-container m__logo-container--header ">
    <Link to="/">
      <img src={logo} alt="Logo"/>
      <p>esartia</p>
    </Link>
    <span id="horizontal"></span>
  </div>
)

export default Header


// WEBPACK FOOTER //
// ./src/components/header.js